import { MarketingTrackingWrapper } from '../../components'

export default function MarketingTrackingPage() {
  return (
    <>
      <MarketingTrackingWrapper />
    </>
  )
}
